import { useEffect } from 'react';
import { useRecoilState } from 'recoil';
import { httpGetUnreadMsg } from '@/services/notify';
import { countMsgState } from '@/store/msgQuantity';

const { NODE_ENV } = process.env;
/**
 * 用户消息数量
 */
export function useMsg(isLoopFetch: boolean = false) {
  const [msgCount, setMsgCount] = useRecoilState(countMsgState);
  // 初始化菜单数据
  useEffect(() => {
    let inter: any;
    if (isLoopFetch) {
      inter = setInterval(
        () => {
          getCountUn();
        },
        NODE_ENV === 'development' ? 10000 : 3000,
      );
    }
    return () => {
      inter && window.clearInterval(inter);
    };
  }, []);
  const getCountUn = () => {
    httpGetUnreadMsg()
      .then((data) => {
        setMsgCount(data);
      });
  };
  const updateMsgCount: any = () => {
    getCountUn();
  };
  return [msgCount, updateMsgCount];
}

export default { useMsg };
